import { gsap } from "gsap";

export default {

  setup() {

    // Simple animation to fade out logo icon element after a few seconds

    gsap.to("#banner-logo", {
      opacity: 0,
      delay: 4,
      duration: 1,
    });

  },
  destroy() {

  },
}